import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MdDashboard } from 'react-icons/md';
import { PageBox } from '../../../components/pageBox';
import { DashboardCard } from '../../../components/dashboardCard';
import { PageHeader } from '../../../components/PageHeader';
import { FloatingAssistant } from '../../../components/floatingAssistent';

export default function ModulesDashBoardPersonnelDepartmentPage() {
  const navigate = useNavigate();
  return (
    <PageBox>
      <PageHeader title="DEPARTAMENTO PESSOAL" subtitle="Esses são os módulos disponíveis" />
      <div className="col-span-2 flex w-full flex-col gap-2 rounded-xl">
        <div className="grid grid-cols-1 gap-6 pb-14 md:grid-cols-2 lg:grid-cols-3 lg:pb-0 2xl:grid-cols-4">
          <DashboardCard
            title="Acompanhamento folha de pagamento"
            value=""
            onClick={() => navigate('/modulesHome/personnelDepartment/payRoll')}
          >
            <div className="flex items-center justify-center rounded-full bg-[#ABEDC6] p-3">
              <MdDashboard color="#219653" className="size-10" />
            </div>
          </DashboardCard>

          <FloatingAssistant />
        </div>
      </div>
    </PageBox>
  );
}
